export const handleSource = (desktop, mobile, screenSize) => {
	return screenSize.width < 640 ? mobile : desktop
}
